import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.889 5.923h5.555a.53.53 0 0 0 .393-.177.63.63 0 0 0 .163-.428.63.63 0 0 0-.163-.427.53.53 0 0 0-.393-.177H7.89a.53.53 0 0 0-.393.177.63.63 0 0 0-.163.427c0 .16.059.314.163.428a.53.53 0 0 0 .393.177m5.555 4.836h-10a.53.53 0 0 0-.392.177.63.63 0 0 0-.163.427c0 .16.058.314.163.428a.53.53 0 0 0 .392.176h10a.53.53 0 0 0 .393-.177.63.63 0 0 0 .163-.427.63.63 0 0 0-.163-.427.53.53 0 0 0-.393-.177M5.111 8.945h8.333a.53.53 0 0 0 .393-.177.63.63 0 0 0 .163-.427.63.63 0 0 0-.163-.428.53.53 0 0 0-.393-.177H5.111a.53.53 0 0 0-.393.177.63.63 0 0 0-.162.428c0 .16.058.314.162.427a.53.53 0 0 0 .393.177"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })